import 'bootstrap/dist/css/bootstrap.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './global.css';
import './styles/theme.css';
import { createRoot } from 'react-dom/client';
import DisplayPage from './app/displayPage';
import { Providers } from './provider';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ToastContainerHome from './components/toast';
import './i18n';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
// eslint-disable-next-line @typescript-eslint/no-var-requires
const $ = require('jquery');
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
	<Router>
		<Providers>
			{/* <EngageNavbar /> */}
			<ToastContainerHome />
			<DisplayPage />
		</Providers>
	</Router>
);
